<template>
  <div class="header">
    <!-- <b-card id="company-details-header" class="rounded-0 mb-2"> -->
    <!-- OLD details -->
    <!-- <div
        style="display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: repeat(3, 1fr); grid-row-gap: 0.75rem;">
        <div class="d-flex">  
          <h5 class="mr-3 mb-0">{{company.companyName}}</h5>
          <star-rating :rating="company.rating" :star-size="20" :increment="0.5"></star-rating>
        </div>
        <div class="d-flex align-items-center">
          <i class="fa fa-sitemap"></i>
          <h5 class="ml-2 mb-0">{{company.companyRolesAsText}}</h5>
        </div>
        <a>Parent Company: {{company.parentCompanyName}}</a>
        <a>{{company.timezone}}</a>
        <a>Company #: {{company.number}}</a>
        <a class="text-muted">{{company.fullName}}: {{company.workPhone1}}</a>
        <a class="text-muted">Scope: {{company.scope}}</a>
    <a>Channel: {{company.shortName}}</a>-->
    <!-- <div class="d-flex">
          <b-form-checkbox checked="true" disabled class="mr-2">
            TPA
          </b-form-checkbox>
          <b-form-checkbox checked="true" disabled class="mr-2">
            Producer
          </b-form-checkbox>
    </div>-->
    <!-- <b-form-checkbox checked="true" disabled class="mr-2">
          Top 10
    </b-form-checkbox>-->
    <!-- <a>Status: {{company.compStatus}}</a>
    </div>-->
    <!-- <div class="grid-item row company-details">
          <table  style="width: 100%">
            <tr>
              <th>Company #: </th>
              <td>{{company.number }}</td>
            </tr>
            <tr>
              <th>Parent Company: </th>
              <td>{{company.parentCompanyName}}</td>
            </tr>
            <tr>
              <th>Channel Name: </th>
              <td>{{company.channelName}}</td>
            </tr>         
          </table>
        </div>
        <div class="grid-item row company-details">
          <table  style="width: 100%">
            <tr>
              <th>Primary Contact: </th>
              <td>{{company.fullName}}: {{company.workPhone1}}</td>
            </tr>
            <tr>
              <th>Scope: </th>
              <td>{{company.scope}}</td>
            </tr>
            
          </table>
    </div>-->
    <div class="grid-container">
      <!-- <div class="grid-item row">
        <b-img v-bind="imgProps" rounded="circle" alt="Circle image"></b-img>
        <div>
            <h4>{{company.companyName}}</h4>
            <h5>{{company.companyRolesAsText}}</h5>
            <star-rating :rating="company.rating" :star-size="20" :increment="0.5"></star-rating>
            <br/>
            <tr>
              <td><span class="company-details"><strong>Status</strong>: &nbsp; {{company.companyStatus}}</span></td>
            </tr>  
        </div>
        <br />
      </div>-->
      <div class="company-details-wrapper row">
        <div>
          <b-img v-bind="imgProps" rounded="circle" alt="Circle image"></b-img>
        </div>
        <div>
          <table borderless class="mr-5">
            <tr>
              <td>
                <span class="company-details">
                  <strong>{{company.companyName}}</strong>
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="company-details">
                  <strong>Company #: {{company.number}}</strong>
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="company-details">
                  <strong>Status: {{company.companyStatus}}</strong>
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="company-details">
                  <strong>Channel: {{company.channelName}}</strong>
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="grid-item row">
        <table borderless class="mr-5">
          <tr>
            <td>
              <span class="company-details">
                <strong>{{company.physicalAddress1}}, {{company.physicalAddress2}}, {{company.physicalCity}}, {{company.physicalState}} {{company.physicalZipcode}}</strong>
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="company-details">
                <strong>{{company.fullName}}: {{company.workPhone1}}</strong>
              </span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="company-details">{{company.website}}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span class="company-details">
                <strong>Top {{company.rating}}</strong>
              </span>
            </td>
          </tr>
        </table>
        <!-- <table borderless>
            <tr>
              <th>Phone: </th>
              <td>{{company.phone}}</td>
            </tr>
            <tr>
              <th>Fax: </th>
              <td>{{company.fax}}</td>
            </tr>
            <tr>
              <th>Email: </th>
              <td>{{company.email}}</td>
            </tr>
            <tr>
              <th>Web: </th>
              <td>{{company.website}}</td>
            </tr>
        </table>-->
        <!-- <i class="fa fa-map-marker mr-2" style="font-size: large"></i><h5>Primary Location</h5> -->
      </div>
      <div></div>
      <div class="grid-item summary-card">
        <b-card class="mb-0" style="grid-column: 5/8; grid-row: 1/6;padding:0">
          <div class="d-flex mb-2">
            <strong class="font-weight-bold mr-2">Total Case Count:</strong>
            <a>7</a>
          </div>
          <div class="d-flex mb-2">
            <strong class="font-weight-bold mr-2">Pending Case Count:</strong>
            <a>1</a>
          </div>
          <div class="d-flex mb-2">
            <strong class="font-weight-bold mr-2">Active Case Count:</strong>
            <a>5</a>
          </div>
          <div class="d-flex">
            <strong class="font-weight-bold mr-2">Total Plan Savings:</strong>
            <a>$384,487</a>
          </div>
        </b-card>
      </div>
    </div>
    <!-- </b-card> -->
    <div class="notes-wrapper">
      <div class="company-details" style="padding-top:10px;text-align:right">
        <strong>Notes:</strong>
      </div>
      <div style="padding-left:10px">
        <b-form-textarea v-model="company.notes" class="h-150"></b-form-textarea>
      </div>
      <div>
        <b-button class="button-menu" @click="saveNotes">Save</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import StarRating from 'vue-star-rating';
//import EditCompany from '@/pages/Company/components/EditCompany';
import { sortAttributes } from '@/shared/helpers';

export default {
  name: 'Header',
  components: {
    StarRating
    //EditCompany,
  },
  props: ['companyId'],
  data() {
    return {
      timezone: null,
      selected: null,
      selectedAttributes: [],
      filteredAttributes: [],
      imgProps: {
        blank: true,
        blankColor: '#66cccc',
        width: 55,
        height: 55,
        class: 'mr-3'
      }
    };
  },
  watch: {
    company: function(company) {
      this.timezone = this.returnTimezoneName(this.company.timezoneId);
      //this.loadCompanyAttributes(company);
    }
  },
  computed: {
    ...mapState('companies', ['company']),
    ...mapGetters('companies', ['companyById']),
    // company() {
    //   return this.companyById(this.companyId);
    // },
    ...mapState('attributes', ['attributes']),
    ...mapState('timezones', ['timezones']),
    compStatus() {
      this.company.status ? 'Active' : 'Inactive';
    }
  },
  methods: {
    ...mapActions('timezones', ['getTimezones']),
    ...mapActions('companies', ['saveCompanyNotes']),
    returnTimezoneName(id) {
      if (!id || !this.timezones || this.timezones.length == 0) return '';

      const result = this.timezones.filter(x => x.id == id);

      return result[0].timeZoneName || null;
    },
    loadCompanyAttributes(company) {
      if (company.accountAttributes != null) {
        this.selectedAttributes = company.accountAttributes.map(
          element => element.attributeId
        );
      }
    },
    async saveNotes() {
      await this.saveCompanyNotes();
    }
  },
  mounted() {
    //this.filteredAttributes = sortAttributes(this.attributes);
    //this.loadCompanyAttributes(this.company);
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

.header {
  &--title {
    margin-right: 1rem;
  }
  color: #ffffff;
  background-image: url(https://ImpaxRX.com/wp-content/uploads/2019/07/tile-grad.jpg);
  background-repeat: repeat-y;
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
}

.no-margin-bottom {
  .form-group {
    margin-bottom: 0;
  }
}

.info-label {
  font-size: 12px;
  font-weight: bold;
  color: $mutedGray;
}

.info-value {
  font-size: 12px;
  font-weight: bold;
  color: #000;
}

.grid-container {
  display: grid;
  grid-template-columns: 25% 25% 25% 20%;
  padding: 10px;
  padding-bottom: 0;
}

.grid-item {
  padding: 20px;
  padding-bottom: 0;
  line-height: 3vh;
}

.company-details {
  font-size: 18px;
}

table {
  border-collapse: collapse;
}

td {
  padding-bottom: 0.5em;
  text-align: justify;
}

th {
  color: #868583;
  padding-bottom: 0.5em;
}
.company-details-wrapper {
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding-bottom: 0;
  line-height: 3vh;
}
.notes-wrapper {
  display: grid;
  grid-template-columns: 10% 70% 15%;
  padding-bottom: 40px;
  padding-top: 20px;
}
.button-menu {
  font-weight: 600 !important;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 03px;
  margin-top: 10px;
  margin-left: 10px;
}
.summary-card {
  line-height: 2vh;
  padding: 0;
  color: black;
}
</style>
